export default {
	name: "indexView", // 关于我们
	data() {
		return {
			navList: [],
			inputStr: "",
		};
	},
	watch: {},
	created() {
		const menuList = JSON.parse(localStorage.getItem("menuList"));
		if (menuList && menuList.data) {
			this.navList = menuList.data;
			console.log("this.navList", this.navList);
		}
	},
	async mounted() {},
	onUpdated() {},
	beforeDestroy() {},
	methods: {},
};